import { Modal } from "antd";
import { FC, useEffect, useState } from "react";
import {
    postDevFrontDebug,
    postMessengerReceivedDelivery,
} from "tm-shared/api";
import { deepParseJson } from "tm-shared/utils";

import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { ModalPayloads, ModalType } from "@/types/modals";

import { StyledConfirmButton, StyledToolIcon } from "./Styled";

export interface StateModalProps {
    payload: ModalPayloads[ModalType.State] | null;
    onCloseModal: () => void;
}

const StateModal: FC<StateModalProps> = ({ payload, onCloseModal }) => {
    const [isSendingState, setIsSendingState] = useState(false);

    useEffect(() => {
        if (payload?.deliveryId) {
            postMessengerReceivedDelivery({
                deliveryId: payload?.deliveryId,
            });
        }
    }, [payload?.deliveryId]);

    if (!payload) return null;

    const handleConfirmSendState = async () => {
        setIsSendingState(true);
        try {
            const stringifiedState = localStorage.getItem("persist:root");
            const debugInfo = deepParseJson(stringifiedState) as Record<
                string,
                unknown
            >;

            const user = debugInfo?.user as { id?: string } | undefined;

            await postDevFrontDebug({
                user: user?.id || "No data",
                debugInfo,
            });
        } catch (error) {
            console.error("Error sending debug info:", error);
        } finally {
            setIsSendingState(false);
            onCloseModal();
        }
    };

    return (
        <Modal title="" closable={false} open centered footer={[]}>
            <PrimaryText
                style={{ textAlign: "center" }}
                fontSize={20}
                fontWeight="500"
            >
                <StyledToolIcon /> Технічний запит
            </PrimaryText>
            <SecondaryText style={{ marginTop: "16px" }}>
                Додаток зареєстрував ситуацію, при якій потрібно надіслати стан
                на сервер
            </SecondaryText>

            <StyledConfirmButton
                type="primary"
                onClick={handleConfirmSendState}
                loading={isSendingState}
            >
                Надіслати
            </StyledConfirmButton>
        </Modal>
    );
};

export default StateModal;
